import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-field', 'required', 'Kohustuslik');
Labels.set('ui-field', 'add', 'Lisa');
Labels.set('ui-field', 'remove', 'Eemalda');
